module.exports = __webpack_public_path__ + "static/media/1POLICY39.7063c5e7.jpg";